import styled from 'styled-components';
import { IconBtnPlusMinus } from './IconBtnPlusMinus';

type Props = {
  label: string;
  open: boolean;
  setOpen: (v: boolean) => void;
};
export const OnOffTitle = ({ label, open, setOpen }: Props) => {
  return (
    <Body onClick={() => setOpen(!open)}>
      <span>{label}</span>
      <div className={'flex-grow'} />
      <IconBtnPlusMinus open={open} setOpen={setOpen} />
    </Body>
  );
};
const Body = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  padding: calc(1.6rem - var(--title-padding-y)) 0rem;
  border-radius: 0.6rem;
  & > * {
    position: relative;
    z-index: 1;
  }
  &:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: -1rem;
    right: -1rem;
    bottom: 0;
    background: #0978ff1a;
    border-radius: 0.8rem;
    z-index: 0;
  }
`;
